'use strict';

angular.module('app')
  .controller('BookingsListCtrl', function ($q, typeURL, Booking, $rootScope, gettextCatalog, Auth) {
    var vm = this;

    vm.activePage = 1;
    vm.pastPage = 1;
    vm.current = typeURL;
    vm.nextPage = nextPage;
    // vm.isAffiliate = typeURL == "aff_bookings" ? true : null;
    vm.isAffiliate = typeURL === 'aff_bookings' && Auth.isAffiliate() || null;

    init();

    function init() {
      vm.loader = true;
      return $q.all([
        Booking.getList({is_affiliate: vm.isAffiliate}),
        Booking.getList({is_past: true, is_affiliate: vm.isAffiliate})
      ])
        .then(function (data) {
          vm.activeAll = data[0];
          vm.pastAll = data[1];
          vm.activeBookings = data[0].results;
          vm.pastBookings = data[1].results;
          vm.allReviews = [];

          vm.loader = false;
        }).catch(function () {
          $rootScope.showNotify(gettextCatalog.getString('Something went wrong'));
        });
    }

    function nextPage(page, isPast) {
      vm.loader = true;

      Booking.getList({page: page, is_past: isPast, is_affiliate: vm.isAffiliate}).then(function (data) {
        vm[isPast ? 'pastBookings' : 'activeBookings'] = data.results;
        vm.loader = false;
      });
    }
  });
